import { render } from "./TableActions.vue?vue&type=template&id=b2de5d4a&scoped=true"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=b2de5d4a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b2de5d4a"

export default script